<ul class="flex flex-col gap-0.5">
  @for (folder of folders(); track folder.guid) {
    <li>
      <div class="flex items-center gap-1">
        @if (folder.children.length) {
          <button
            type="button"
            (click)="onToggle(folder)"
            [attr.aria-expanded]="isOpen(folder)"
            [attr.aria-label]="folder.titel"
            class="shrink-0 cursor-pointer rounded p-1 text-cmi-gray-mid hover:bg-cmi-gray-light hover:text-main">
            <svg
              class="h-4 w-4 transition-transform duration-200"
              [class.rotate-90]="isOpen(folder)"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M9 5l7 7-7 7" />
            </svg>
          </button>
        } @else if (hasBranches()) {
          <span class="w-6 shrink-0" aria-hidden="true"></span>
        }

        <button
          type="button"
          (click)="folderSelect.emit(folder)"
          [attr.aria-pressed]="folder.guid === selectedGuid()"
          class="flex min-w-0 flex-1 cursor-pointer items-center gap-2 rounded-md px-2 py-1.5 text-left text-sm"
          [ngClass]="
            folder.guid === selectedGuid()
              ? 'bg-main-light font-medium text-main'
              : 'text-cmi-gray hover:bg-cmi-gray-light'
          ">
          <svg
            class="h-4 w-4 shrink-0"
            [ngClass]="folder.guid === selectedGuid() ? 'text-main' : 'text-cmi-gray-mid'"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M3 7a2 2 0 012-2h3.9a2 2 0 011.7.9l.8 1.2a2 2 0 001.7.9H19a2 2 0 012 2v7a2 2 0 01-2 2H5a2 2 0 01-2-2V7z" />
          </svg>
          <span class="truncate">{{ folder.titel }}</span>
          @if (folder.guid === plannedGuid) {
            <span
              class="shrink-0 rounded bg-cmi-gray-light px-1.5 text-xs font-normal text-cmi-gray-mid">
              {{ 'dossierDetail.newFolderBadge' | translate }}
            </span>
          }
        </button>

        @if (folder.guid === plannedGuid) {
          <button
            type="button"
            (click)="plannedFolderRemove.emit()"
            [attr.aria-label]="
              'dossierDetail.newFolderRemove' | translate: { folder: folder.titel }
            "
            [title]="'dossierDetail.newFolderRemove' | translate: { folder: folder.titel }"
            class="shrink-0 cursor-pointer rounded p-1 text-cmi-gray-mid hover:bg-cmi-gray-light hover:text-main">
            <svg
              class="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 6l12 12M18 6L6 18" />
            </svg>
          </button>
        } @else if (canCreate()) {
          <button
            type="button"
            (click)="onNewFolderStart(folder)"
            [attr.aria-label]="'dossierDetail.newFolderIn' | translate: { folder: folder.titel }"
            [title]="'dossierDetail.newFolderIn' | translate: { folder: folder.titel }"
            class="shrink-0 cursor-pointer rounded p-1 text-cmi-gray-mid hover:bg-cmi-gray-light hover:text-main">
            <svg
              class="h-4 w-4"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 5v14M5 12h14" />
            </svg>
          </button>
        }
      </div>

      @if (isOpen(folder) && (folder.children.length || isNewFolderParent(folder))) {
        <!-- The line runs below the parent's chevron, the children start below its name. -->
        <div class="mt-0.5 ml-3 border-l border-cmi-gray-light pl-[15px]">
          @if (newFolder(); as draft) {
            @if (draft.parentGuid === folder.guid) {
              <cmi-new-folder-form
                class="block"
                [class.pl-3]="!hasChildBranches(folder)"
                [draft]="draft"
                (titleChange)="newFolderTitleChange.emit($event)"
                (add)="newFolderAdd.emit()"
                (discard)="newFolderDiscard.emit()" />
            }
          }
          @if (folder.children.length) {
            <cmi-folder-tree
              class="block"
              [class.pl-3]="!hasChildBranches(folder)"
              [folders]="folder.children"
              [selectedGuid]="selectedGuid()"
              [newFolder]="newFolder()"
              [canCreate]="canCreate()"
              (folderSelect)="folderSelect.emit($event)"
              (newFolderStart)="newFolderStart.emit($event)"
              (newFolderTitleChange)="newFolderTitleChange.emit($event)"
              (newFolderAdd)="newFolderAdd.emit()"
              (newFolderDiscard)="newFolderDiscard.emit()"
              (plannedFolderRemove)="plannedFolderRemove.emit()" />
          }
        </div>
      }
    </li>
  }
</ul>
